const init = (root = document) => {
  const buttons=[...root.querySelectorAll('[data-spice-filter]')];
  const cards=[...root.querySelectorAll('[data-spice-card]')];
  const empty=root.querySelector('[data-spice-empty]');
  if(!cards.length)return;
  let query=new URLSearchParams(location.search).get('q')?.trim().toLowerCase()||'';
  const categoryForHash = { '#whole-spices':'Whole Spices', '#ground-spices':'Ground Herbs & Spices', '#classic-blends':'Classic Blends' };
  let active=categoryForHash[location.hash]||'all';
  const render=()=>{
    cards.forEach(card=>{card.hidden=!(active==='all'||card.dataset.category===active)||!!query&&!card.dataset.searchText.includes(query);});
    buttons.forEach(button=>{const chosen=button.dataset.spiceFilter===active;button.classList.toggle('is-active',chosen);button.setAttribute('aria-pressed',String(chosen));});
    if(empty)empty.hidden=cards.some(card=>!card.hidden);
  };
  buttons.forEach(button=>button.addEventListener('click',()=>{active=button.dataset.spiceFilter||'all';query='';render();const hash=Object.entries(categoryForHash).find(([,category])=>category===active)?.[0]||'';history.replaceState(null,'',location.pathname+hash);}));
  window.addEventListener('hashchange',()=>{active=categoryForHash[location.hash]||'all';render();});
  render();
};
init();
document.addEventListener('shopify:section:load',event=>{if(event.target instanceof Element&&event.target.querySelector('.ingredient-collection'))init(event.target);});
